import {
  CreatePromotionCodeRequest,
  PromotionCode,
  PromotionCodeAnalytics,
  PromotionCodeDetail,
  PromotionCodeList,
  PromotionCodeValidationResult,
  UpdatePromotionCodeRequest,
  ValidatePromotionCodeRequest,
} from "../types/admin";
import { ApiResponse } from "../types/common";
import { withServiceFeeAlias } from "../utils/serviceFeePayload";

import apiClient from "./apiClient";

export const getPromotionCodes = async (): Promise<
  ApiResponse<PromotionCodeList[]>
> => {
  const response = await apiClient.get("/admin/promotion-codes");
  return response.data;
};

export const getPromotionCodeById = async (
  id: string,
): Promise<ApiResponse<PromotionCode>> => {
  const response = await apiClient.get(`/admin/promotion-codes/${id}`);
  return response.data;
};

export const getPromotionCodeDetail = async (
  id: string,
): Promise<ApiResponse<PromotionCodeDetail>> => {
  const response = await apiClient.get(`/admin/promotion-codes/${id}/detail`);
  return response.data;
};

export const createPromotionCode = async (
  data: CreatePromotionCodeRequest,
): Promise<ApiResponse<PromotionCode>> => {
  const response = await apiClient.post("/admin/promotion-codes", data);
  return response.data;
};

export const updatePromotionCode = async (
  id: string,
  data: UpdatePromotionCodeRequest,
): Promise<ApiResponse<PromotionCode>> => {
  const response = await apiClient.put(`/admin/promotion-codes/${id}`, data);
  return response.data;
};

export const deletePromotionCode = async (
  id: string,
): Promise<ApiResponse<object>> => {
  const response = await apiClient.delete(`/admin/promotion-codes/${id}`);
  return response.data;
};

export const activatePromotionCode = async (
  id: string,
): Promise<ApiResponse<boolean>> => {
  const response = await apiClient.put(`/admin/promotion-codes/${id}/activate`);
  return response.data;
};

export const deactivatePromotionCode = async (
  id: string,
): Promise<ApiResponse<boolean>> => {
  const response = await apiClient.put(
    `/admin/promotion-codes/${id}/deactivate`,
  );
  return response.data;
};

export const getPromotionCodeAnalytics = async (
  codeId: string,
): Promise<ApiResponse<PromotionCodeAnalytics>> => {
  const response = await apiClient.get(
    `/admin/promotion-codes/analytics/${codeId}`,
  );
  return response.data;
};

export const getPromotionCodeAnalyticsList = async (): Promise<
  ApiResponse<PromotionCodeAnalytics[]>
> => {
  const response = await apiClient.get("/admin/promotion-codes/analytics");
  return response.data;
};

export const validatePromotionCode = async (
  data: ValidatePromotionCodeRequest,
): Promise<ApiResponse<PromotionCodeValidationResult>> => {
  const response = await apiClient.post(
    "/promotion-codes/validate",
    withServiceFeeAlias(data)
  );
  return response.data;
};

